/* Gut rhythm advertorial. Native reference controls scoped to their section. */
;(function () {
  function boot(root) {
    if (root.dataset.graReady) return
    root.dataset.graReady = "true"
    var abort = new AbortController(),
      observers = [],
      timers = new Set()
    var id = function (name) {
      return root.querySelector('[data-gra-id="' + name + '"]')
    }
    var all = function (selector) {
      return root.querySelectorAll(selector)
    }
    var motion = window.matchMedia("(prefers-reduced-motion: reduce)"),
      reduced = motion.matches
    function later(callback, ms) {
      var timer = setTimeout(function () {
        timers.delete(timer)
        if (!abort.signal.aborted) callback()
      }, ms)
      timers.add(timer)
      return timer
    }
    function makeObserver(callback, options) {
      var observer = new IntersectionObserver(callback, options)
      observers.push(observer)
      return observer
    }
    root.addEventListener(
      "click",
      function (event) {
        var link = event.target.closest('a[href^="#"]')
        if (!link || !root.contains(link)) return
        var target = document.getElementById(link.hash.slice(1))
        if (!target || !root.contains(target)) return
        event.preventDefault()
        target.scrollIntoView({
          behavior: motion.matches ? "auto" : "smooth",
          block: "start",
        })
        if (!target.hasAttribute("tabindex"))
          target.setAttribute("tabindex", "-1")
        target.focus({ preventScroll: true })
      },
      { signal: abort.signal }
    )
    function refreshOffer() {
      var api = window.SchumannActiveOffer,
        node = root.querySelector("[data-active-offer-config]")
      if (!api || !node) return
      var config
      try {
        config = JSON.parse(node.textContent)
      } catch (_) {
        return
      }
      if (api.isLive(config)) return
      all("[data-aoc-only]").forEach(function (n) {
        n.hidden = true
      })
      all("[data-aoc-price-output]").forEach(function (n) {
        n.textContent = n.dataset.aocRegular
      })
      all("a[data-gra-buy]").forEach(function (n) {
        n.href = api.link(n.dataset.aocBaseHref, config, false)
      })
    }
    root.addEventListener("click", refreshOffer, {
      signal: abort.signal,
      capture: true,
    })
    window.addEventListener("pageshow", refreshOffer, { signal: abort.signal })

    // Shelf
    var shelf = all('[data-gra-id="shelf"] button')
    var sr = id("shelfResult")
    function upd() {
      var n = all('[data-gra-id="shelf"] button[aria-pressed="true"]').length
      if (!n) {
        sr.innerHTML = ""
        return
      }
      var msg =
        n === 1
          ? "One thing tried, and it works on what goes in. Keep reading for what it can\u2019t reach."
          : n < 4
            ? n +
              " things tried. Every one of them works on what you eat. None of them works on rhythm."
            : n +
              " things tried. That\u2019s real effort... and they all share the same blind spot."
      sr.innerHTML =
        '<span class="count">' +
        n +
        " of " +
        shelf.length +
        " tried</span><p>" +
        msg +
        "</p>"
    }
    shelf.forEach(function (b) {
      b.addEventListener("click", function () {
        b.setAttribute(
          "aria-pressed",
          b.getAttribute("aria-pressed") !== "true"
        )
        upd()
      })
    })

    // Objections accordion
    all(".obj button").forEach(function (b) {
      b.addEventListener("click", function () {
        var open = b.getAttribute("aria-expanded") === "true"
        b.setAttribute("aria-expanded", !open)
        b.nextElementSibling.classList.toggle("open", !open)
        b.nextElementSibling.hidden = open
      })
    })

    // Gut-brain line
    var nerve = id("gbNerve")
    var dotsG = id("gbDots")
    var L = nerve.getTotalLength()
    var NS = "http://www.w3.org/2000/svg"
    var dots = []
    for (var i = 0; i < 9; i++) {
      var up = i < 7
      var c = document.createElementNS(NS, "circle")
      c.setAttribute("r", up ? 5 : 4)
      c.setAttribute("fill", up ? "#f2b8cf" : "#b9a2ea")
      c.setAttribute("stroke", "#000")
      c.setAttribute("stroke-width", "1.2")
      dotsG.appendChild(c)
      dots.push({ el: c, up: up, t: Math.random() })
    }
    var stress = id("stress")
    var gut = id("gbGut")
    var reduce = reduced,
      animationId,
      animationVisible = true
    function place() {
      dots.forEach(function (d) {
        var pos = d.up ? 1 - d.t : d.t
        var pt = nerve.getPointAtLength(pos * L)
        d.el.setAttribute("cx", pt.x)
        d.el.setAttribute("cy", pt.y)
      })
    }
    var last = performance.now()
    function frame(now) {
      var dt = Math.min(0.05, (now - last) / 1000)
      last = now
      var v = +stress.value
      var speed = 0.12 + (v / 100) * 0.5
      dots.forEach(function (d) {
        d.t = (d.t + dt * speed * (d.up ? 1 : 0.8)) % 1
      })
      place()
      if (
        !reduce &&
        !document.hidden &&
        animationVisible &&
        !abort.signal.aborted
      )
        animationId = requestAnimationFrame(frame)
    }
    place()
    if (
      !reduce &&
      !document.hidden &&
      animationVisible &&
      !abort.signal.aborted
    )
      animationId = requestAnimationFrame(frame)
    function gbUpdate() {
      var v = +stress.value
      var word = v < 34 ? "Calm" : v < 67 ? "Busy" : "Frazzled"
      var state =
        v < 34 ? "Rest and digest" : v < 67 ? "On alert" : "Fight or flight"
      var text =
        v < 34
          ? "Pink dots travel gut to brain, purple dots brain to gut. Most of the traffic runs upwards, and digestion gets the green light."
          : v < 67
            ? "The signals speed up. Your body starts quietly turning digestion down to deal with everything else."
            : "Digestion is on hold. This is the knot under your ribs, the lost appetite, the bloating that shows up after a hard day."
      id("stressWord").textContent = word
      id("gbState").textContent = state
      id("gbText").textContent = text
      stress.setAttribute("aria-valuetext", v + "%: " + word)
      gut.setAttribute(
        "class",
        v < 34 ? "gut-calm" : v < 67 ? "gut-busy" : "gut-knot"
      )
      stress.style.setProperty("--p", v + "%")
    }
    stress.addEventListener("input", gbUpdate)
    gbUpdate()

    // Holiday dinner clock (24h bars run 06:00 to 06:00; gut night window ~22:00 to 06:00)
    var dinner = id("dinner"),
      zones = id("zones")
    function hhmm(h) {
      h = ((h % 24) + 24) % 24
      var hr = Math.floor(h),
        mi = Math.round((h - hr) * 60)
      return (hr < 10 ? "0" : "") + hr + ":" + (mi < 10 ? "0" : "") + mi
    }
    function posOf(h) {
      return (((((h - 6) % 24) + 24) % 24) / 24) * 100
    }
    function dc() {
      var dh = +dinner.value / 2
      var z = +zones.value
      var gutH = dh + z * dir
      id("dinnerOut").textContent = hhmm(dh)
      id("zonesOut").textContent =
        z === 0 ? "0" : z + (z === 1 ? " zone" : " zones")
      id("mLocal").style.left = posOf(dh) + "%"
      id("mGut").style.left = posOf(gutH) + "%"
      ;[
        ["mLocal", posOf(dh)],
        ["mGut", posOf(gutH)],
      ].forEach(function (pair) {
        id(pair[0]).style.setProperty(
          "--gra-label-shift",
          pair[1] > 80 ? "-100%" : pair[1] < 20 ? "0%" : "-50%"
        )
      })
      id("mGutLbl").textContent = z ? "Feels like " + hhmm(gutH) : "Dinner"
      var gh = ((gutH % 24) + 24) % 24
      var msg
      if (z === 0) {
        msg =
          dh <= 19
            ? "<b>Good timing.</b> Dinner lands while your gut is still in its daytime rhythm."
            : dh < 21
              ? "<b>Getting late.</b> Your gut is starting to wind down while dinner is still arriving."
              : "<b>Holiday dinner territory.</b> Your gut is heading into its overnight rhythm with a full plate still to deal with."
      } else {
        msg =
          "<b>Dinner at " +
          hhmm(dh) +
          " local is " +
          hhmm(gutH) +
          " on your gut\u2019s clock.</b> " +
          (gh >= 22 || gh < 5
            ? "As far as your gut is concerned, it\u2019s the middle of the night."
            : gh >= 19
              ? "Your gut thinks it should be winding down for the night."
              : "Your gut is eating on a clock it hasn\u2019t caught up with yet.") +
          " In the jet lag study, gut rhythms only settled back once the jet lag wore off."
      }
      id("dcMsg").innerHTML = msg
      dinner.style.setProperty("--p", ((+dinner.value - 34) / 13) * 100 + "%")
      zones.style.setProperty("--p", (z / 8) * 100 + "%")
    }
    var dir = 1
    all(".dc-dir button").forEach(function (b) {
      b.addEventListener("click", function () {
        all(".dc-dir button").forEach(function (x) {
          x.setAttribute("aria-pressed", "false")
        })
        b.setAttribute("aria-pressed", "true")
        dir = +b.dataset.d
        dc()
      })
    })
    dinner.addEventListener("input", dc)
    zones.addEventListener("input", dc)
    dc()

    // Chat interstitials: typing, then the answer, when scrolled into view
    all("[data-chat]").forEach(function (c) {
      c.classList.add("js")
      if (reduced) {
        c.classList.add("done")
        return
      }
      function play() {
        if (c.dataset.played) return
        c.dataset.played = "1"
        c.classList.add("typing-on")
        later(function () {
          c.classList.remove("typing-on")
          c.classList.add("done")
        }, 1300)
      }
      if ("IntersectionObserver" in window) {
        var io = makeObserver(
          function (es) {
            es.forEach(function (e) {
              if (e.isIntersecting) {
                play()
                io.disconnect()
              }
            })
          },
          { threshold: 0.5 }
        )
        io.observe(c)
      } else {
        play()
      }
    })

    // Stop the continuous illustration offscreen, on hidden tabs and on section removal.
    function syncAnimation() {
      cancelAnimationFrame(animationId)
      if (
        !reduce &&
        !document.hidden &&
        animationVisible &&
        !abort.signal.aborted
      ) {
        last = performance.now()
        animationId = requestAnimationFrame(frame)
      }
    }
    if ("IntersectionObserver" in window) {
      makeObserver(
        function (entries) {
          animationVisible = entries.some(function (e) {
            return e.isIntersecting
          })
          syncAnimation()
        },
        { rootMargin: "120px" }
      ).observe(id("gutBrain"))
    }
    document.addEventListener(
      "visibilitychange",
      function () {
        if (!document.hidden) refreshOffer()
        syncAnimation()
      },
      { signal: abort.signal }
    )
    motion.addEventListener(
      "change",
      function () {
        reduce = motion.matches
        syncAnimation()
      },
      { signal: abort.signal }
    )
    var key = root.dataset.yotpoStore,
      product = root.dataset.yotpoProduct
    if (key && product) {
      fetch(
        "https://api-cdn.yotpo.com/v3/storefront/store/" +
          encodeURIComponent(key) +
          "/product/" +
          encodeURIComponent(product) +
          "/reviews?perPage=100&page=1",
        { headers: { accept: "application/json" }, signal: abort.signal }
      )
        .then(function (response) {
          if (!response.ok) throw Error("Reviews unavailable")
          return response.json()
        })
        .then(function (data) {
          if (abort.signal.aborted) return
          var reviews = data.reviews || [],
            bottom = data.bottomline || {}
          all("[data-gra-review]").forEach(function (card) {
            var review = reviews.find(function (r) {
              return String(r.id) === card.dataset.graReview
            })
            if (
              !review ||
              !review.content ||
              !review.user ||
              !(review.score > 0)
            )
              return
            card.querySelector("[data-gra-quote]").textContent = review.content
            card.querySelector("[data-gra-author]").textContent =
              review.user.displayName
            var stars = card.querySelector("[data-gra-stars]")
            stars.textContent = "★".repeat(
              Math.min(5, Math.max(0, Math.round(review.score)))
            )
            stars.setAttribute("aria-label", review.score + " out of 5 stars")
            card.querySelector("[data-gra-verified]").hidden =
              review.verifiedBuyer !== true
            card.hidden = false
            var aside = card.closest(".sf-side")
            if (aside) aside.hidden = false
            all("[data-gra-proof-note]").forEach(function (n) {
              n.hidden = false
            })
          })
          if (
            Number(bottom.totalReview) > 0 &&
            Number(bottom.averageScore) > 0
          ) {
            all("[data-gra-rating]").forEach(function (node) {
              var b = document.createElement("b")
              b.textContent = Number(bottom.averageScore).toFixed(1) + "/5"
              node.replaceChildren(b, " V1 Classic rating")
              node.hidden = false
            })
          }
        })
        .catch(function () {
          /* Missing or failed reviews remain hidden, without invented fallback. */
        })
    }
    document.addEventListener(
      "shopify:section:unload",
      function (event) {
        if (!event.target.contains(root)) return
        abort.abort()
        cancelAnimationFrame(animationId)
        observers.forEach(function (o) {
          o.disconnect()
        })
        timers.forEach(clearTimeout)
        delete root.dataset.graReady
      },
      { signal: abort.signal }
    )
  }
  function start() {
    document.querySelectorAll("[data-gra-page]").forEach(boot)
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", start, { once: true })
  else start()
  document.addEventListener("shopify:section:load", start)
})()
